import type { App } from 'vue'

// 需要全局引入一些组件，如ElScrollbar，不然一些下拉项样式有问题
import {
  ElLoading,
  ElScrollbar,
  ElButton,
  ElForm,
  ElInput,
  ElTag,
  ElTable,
  ElIcon,
  ElPagination,
  ElDatePicker,
  ElSelect,
  ElOption,
  ElDialog,
  ElInputNumber,
  ElTooltip,
  ElRow,
  ElCol,
  ElUpload,
  ElProgress,
  ElImage,
  ElPopover,
  ElRadio,
  ElRadioGroup,
  ElFormItem,
  ElDescriptions,
  ElDescriptionsItem,
  ElAlert,
  ElDrawer,
  ElCard
} from 'element-plus'

const plugins = [
  ElLoading,
  ElButton,
  ElForm,
  ElInput,
  ElTag,
  ElTable,
  ElIcon,
  ElPagination,
  ElDatePicker,
  ElSelect,
  ElOption,
  ElDialog,
  ElInputNumber,
  ElTooltip,
  ElRow,
  ElCol,
  ElUpload,
  ElProgress,
  ElImage,
  ElPopover,
  ElRadio,
  ElRadioGroup,
  ElForm,
  ElFormItem,
  ElDescriptions,
  ElDescriptionsItem,
  ElAlert,
  ElDrawer,
  ElCard
]

const components = [ElScrollbar]

export const setupElementPlus = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // 为了开发环境启动更快，一次性引入所有样式
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('element-plus/dist/index.css')
    return
  }

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
